import { useState } from "react";
import { api } from "../../../../../../utility/api";

export const BultosSkimApi = () => {
    const [cargando, setCargando] = useState(false);

    const getAlmacenesSkim = async (params) => {
        const finalParams = {
            no_paginar: true,
            requiere_bultos_skim: true,
            filtrar_acopio: true,
            ...params,
        };

        return api
            .get("bodega/get_almacenes", finalParams)
            .then((data) => {
                if (data) return data.results;
                return [];
            })
            .catch(() => {
                return [];
            });
    };

    const getBultosSkim = async (params) => {
        try {
            setCargando(true);
            const response = await api.get(`bultos_skim`, params);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const agregarBultoSkim = async (data) => {
        try {
            setCargando(true);

            const response = await api.post(`bultos_skim`, data);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const getTotalesBultosSkim = async () => {
        try {
            setCargando(true);
            const response = await api.get(`bultos_skim/totales_bultos_skim`);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const descartarBultoSkim = async (id) => {
        try {
            setCargando(true);
            await api.eliminar(`bultos_skim/${id}`);
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    }

    return {
        getAlmacenesSkim,
        getBultosSkim,
        agregarBultoSkim,
        getTotalesBultosSkim,
        descartarBultoSkim,

        cargando,
    };
};
